<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="z-title z-title--small">
          Mensalidades atrasadas
        </div>

        <p class="z-text spacer-bottom-l">
          Pague as mensalidades atrasadas e evite o cancelamento da bolsa.
        </p>

        <list-loader v-if="loadingData" :list-size="2" />

        <accordion
          :title="bill.month_name"
          :open="overdueBills.length === 1"
          :key="bill.id"
          v-else-if="overdueBills.length > 0"
          v-for="bill in overdueBills"
        >
          <overdue-bill-info :bill="bill" />
        </accordion>

        <empty-bills
          v-else
          title="Sem mensalidades atrasadas"
          description="Não encontramos nenhuma mensalidade atrasada."
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Accordion from 'components/accordion';
import Breadcrumb from 'components/breadcrumb';
import ListLoader from 'content-loaders/list-loader';
import EmptyBills from 'components/empty-bills';
import OverdueBillInfo from 'components/bill-list/overdue-bill-info';

export default {
  components: {
    Accordion,
    Breadcrumb,
    EmptyBills,
    OverdueBillInfo,
    ListLoader,
  },
  data() {
    return {
      loadingData: true,
    };
  },
  computed: {
    ...mapState([
      'overdueBills',
    ]),
  },
  methods: {
    ...mapActions([
      'loadOverdueBills',
    ]),
  },
  mounted() {
    this.loadOverdueBills()
      .then(() => {
        this.loadingData = false;
      })
      .catch((error) => this.$rollbar.error(error));
    this.$tracker.logEvent('Viewed Overdue Bills Page');
  },
};
</script>
